export const fonts = {
  SFProDisplay: "SFProDisplay",
  SFProDisplayRegular: "SFProDisplay-Regular",
  SFProDisplayMedium: "SFProDisplay-Medium",
  SFProDisplaySemiBold: "SFProDisplay-Semibold",
  SFProDisplayBold: "SFProDisplay-Bold",
};